import { render, staticRenderFns } from "./icon-order.vue?vue&type=template&id=91507f88"
import script from "./icon-order.vue?vue&type=script&lang=js"
export * from "./icon-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports